export default {"src":"/_next/static/media/linkedin-logo.6a1e2b29.svg","height":800,"width":800,"blurWidth":0,"blurHeight":0};